import React, { useState } from 'react';
import { Radio } from '@material-ui/core';
import DialogBox from '../DialogBox';
import DrawerPwa from '../DrawerPwa';
import PHBackButton from '../PHBackButton';
import css from './index.module.scss';
import Loader from '../Loader';
import { Redux, Slices } from 'spwa-ui-library';
import { useLocation, useNavigate } from '@reach/router';
import { useIntl } from 'react-intl';

const { useSelector } = Redux;
const { selectDesktop } = Slices.appSlice;
const { selectProductEntities } = Slices.productSlice;
const { selectCountryValidations } = Slices.configSlice;
const { selectCurrentCountry } = Slices.profileSlice;

function BundleGroupDialog({
  showBundleGroupDialog,
  setShowBundleGroupDialog,
  handleBundleGroupAction,
  backHandler = false,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const intl = useIntl();
  const [pageLoader, setPageLoader] = useState(false);
  const locationSearch = new URLSearchParams(location.search);
  const [checkedOption, setCheckedOption] = useState(0);

  const productsMap = useSelector(selectProductEntities);
  const isDesktop = useSelector(selectDesktop);

  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const currency = countryValidations && countryValidations.currency;

  const handleBack = () => {
    if (location.state?.oldLocation?.pathname?.includes('home')) {
      // user is coming from homepage
      navigate(`/${intl.locale}/home`);
    } else {
      if (backHandler) {
        const windowLength = window.history.length;

        if (windowLength < 3) {
          navigate(`/${intl.locale}/home`);
        } else {
          navigate(-1);
        }
      }
      setShowBundleGroupDialog(0);
    }
  };

  const handleAction = (optionId) => {
    setPageLoader(true);
    setCheckedOption(optionId);
    localStorage.removeItem('isBackNotPressed');
    setTimeout(() => {
      handleBundleGroupAction(optionId);
    }, 500);
  };

  const renderContent = () => (
    <div className={css.dropcart}>
      <div className={css.bundledialogcontent}>
        {!isDesktop && (
          <div className={css.title}>
            <span>
              {productsMap[showBundleGroupDialog]?.variants?.[0]?.title ||
                productsMap[showBundleGroupDialog]?.title}
            </span>
            <PHBackButton onclick={handleBack} cross={true} />
          </div>
        )}
        {productsMap[showBundleGroupDialog]?.variants[0]?.options?.map((option) => {
          let description = option?.description;
          let price =
            option?.price >= 0 ? option?.price : option?.specialPrice || option?.originalPrice;
          if (!description) {
            let currentItem;
            const optionId = option?.id;
            for (let item of productsMap[showBundleGroupDialog]?.items) {
              let itemInfo;
              if (item?.id) {
                itemInfo = item;
              } else {
                itemInfo = productsMap[item];
              }

              if (itemInfo?.sel1Value == optionId) {
                currentItem = itemInfo;
                break;
              }
            }

            description = currentItem?.description;
            price =
              currentItem?.price >= 0
                ? currentItem?.price
                : currentItem?.specialPrice || currentItem?.originalPrice;
          }
          return (
            <div className={css.bundleGroupOption} onClick={() => handleAction(option?.id)}>
              <div className={css.optionRow1}>
                <span className={css.bundleGroupOptionTitle}>
                  {`${option.title}${price ? ` (${price} ${currency})` : ``}`}
                </span>
                <Radio
                  color="primary"
                  id={option?.id}
                  edge="end"
                  checked={
                    checkedOption == option?.id ||
                    (locationSearch.has('option') && locationSearch.get('option') == option?.id)
                  }
                  onClick={() => handleAction(option?.id)}
                />
              </div>
              <div className={css.optionRow2}>{description}</div>
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <>
      {isDesktop ? (
        <DialogBox
          title={
            productsMap[showBundleGroupDialog]?.variants?.[0]?.title ||
            productsMap[showBundleGroupDialog]?.title
          }
          size="md"
          className={css.dealSelectionDialog}
          isOpen={showBundleGroupDialog}
          hideCloseButton={true}
          onClose={handleBack}
        >
          {renderContent()}
        </DialogBox>
      ) : (
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          className={css.dealSelectionDialog}
          open={showBundleGroupDialog}
          extraClass={css.bundleSelector}
          onClose={handleBack}
          hideCloseButton={true}
        >
          {renderContent()}
        </DrawerPwa>
      )}
      {pageLoader && <Loader />}
    </>
  );
}

export default BundleGroupDialog;
